import {Component, OnDestroy, OnInit} from "@angular/core";
import {AlertQualityGate} from "../../../api/models/alert-quality-gate";
import {interval} from "rxjs";
import {AlertQualityGateService} from "../../../api/services/alert-quality-gate.service";

@Component({
  selector: "app-quality-gate",

  templateUrl: "./quality-gate.component.html",
  styleUrl: "./quality-gate.component.css",
  standalone: false,
})
export class QualityGateComponent implements OnInit, OnDestroy {

  selectedMainTabIndex: number = 0;
  alerts: AlertQualityGate[] = [];
  private _subscription: any;

  constructor(private _alertQualityGateService: AlertQualityGateService) {
  }

  ngOnInit(): void {
    this.getAlertsForQualityGate();
    this._subscription = interval(120000).subscribe(() => {
      this.getAlertsForQualityGate();
    });
  }

  onMainTabChange(index: string | number): void {
    this.selectedMainTabIndex = +index;
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private getAlertsForQualityGate() {
    this._alertQualityGateService.getAlertsForQualityGates().subscribe({
      next: value => {
        this.alerts = value;
       }
    });
  }

}
